import { useInfiniteQuery } from '@tanstack/react-query';
import { useDebounce } from '@/hooks/use-debounce';
import { useColocApi } from '@/hooks/use-coloc-api';
import { getRoomsWithTenants, RoomWithTenant, RoomListSortType } from '@/lib/coloc-api/admin';

const useGetRoomsWithTenants = (params: {
  searchQuery?: string;
  selectedHouseId?: number;
}) => {
  const { setPage, setPageLimit, page, pageLimit } =
    useColocApi<RoomListSortType>()!;
  const debouncedSearchQuery: string = useDebounce(
    params.searchQuery ?? '',
    500
  );

  const fetch = useInfiniteQuery({
    queryKey: [
      'getRoomsWithTenants',
      debouncedSearchQuery,
      page,
      pageLimit,
      params.selectedHouseId,
    ],
    queryFn: ({ pageParam = 1 }) =>
      getRoomsWithTenants({
        page_limit: 20,
        ...(pageParam && { page: pageParam }),
        ...(debouncedSearchQuery &&
          debouncedSearchQuery !== '' && { query: debouncedSearchQuery }),
        ...(params.selectedHouseId && { house_id: params.selectedHouseId }),
      }),
    keepPreviousData: true,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.data.pagination.total_pages > pages.length) {
        return pages.length + 1;
      }
      return undefined;
    },
    enabled: true,
  });

  return {
    pageLimit,
    setPageLimit,
    fetch,
    setPage,
  };
};

export { useGetRoomsWithTenants };
export type { RoomWithTenant };

